import { useState, useEffect } from 'react'
import Styles from './styles.module.sass'
import { showLoader, hideLoader } from 'store/actions/commons';
import { useStore } from 'store'
import { decodeStorage, encodeStorage, encodeStorageLatin } from 'functions/storageBase64';
import { BASE_PATH_API } from 'constants/env';
import { useHistory } from 'react-router-dom';
import useEventGifts from 'newHooks/useEventGifts';
import { setGiftTable } from 'store/actions/giftTable'
import ModalCloseGT from '../Modal'
import iconregalo from 'assets/img/iconregalo.svg'
import PaginationList from 'newComponents/pagination';


const useTotalEventsGifts = () => {
    const userProfile = decodeStorage('profileData')
    const idSears = String(userProfile?.idClaro)
    const [ giftTable, dispatch ] = useStore( (state) => state?.giftTable?.myListOfGiftsTables)

    const history = useHistory();
    const {
        getEventTable,
        responseTable,
    } = useEventGifts()


    const sanitizeData = (data) => {
        let newData
        let meses = ['ENE','FEB','MAR','ABR','MAY','JUN','JUL','AGO','SEP','OCT','NOV','DIC']
        if(data){
            newData = data?.map(events => {
                let nombres = events?.celebrate_labels[1] ? `${events?.celebrate_labels[0]?.label?.value} y ${events?.celebrate_labels[1]?.label?.value}` : events?.celebrate_labels[0]?.label?.value
                let eventos = events?.event_name
                let numEventos = events?.id
                let fecha = events?.date?.split(' ')[0]?.split('-')
                let fechaFormat = `${fecha[2]}/${meses[fecha[1]-1]}/${fecha[0].substr(-2)}`
                let status = events?.status
                let plan = events?.plan_name
                let otroNombre = events?.name

                return {
                    estatus: status,
                    evento: numEventos,
                    fecha: fechaFormat,
                    festejados: nombres,
                    id: numEventos,
                    nombre: otroNombre,
                    plan: plan,
                    tipo: eventos
                }
            })
        }
        return newData
    }

    const sanitizePagination = (data) => {
        let newData
        if(data){
            newData = {
                current_page: 1,
                items_per_page: 20,
                total_items: data?.totalElements,
                total_pages: data?.totalPages
            }
        }
        return newData
    }

    // va por servicio de Eventos
    const [ response, setResponse ] = useState()
    const [ responsePag, setResponsePag ] = useState()
    
    const serverListCarts = async (page) => {
        // window.localStorage.removeItem('localCartEvents')
        dispatch(showLoader());
        try {
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table?customer_sears_id=${idSears}&page=${page}&page_num=${page}&order_by=&items_per_page=`);
            const data = await response.json();
            if(data?.data){
                setResponse( sanitizeData(data?.data) )
                setResponsePag( data?.pagination ) 
                dispatch(hideLoader());
            }
        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
            dispatch(hideLoader());
        }
    }
    
    const [ responseRemove, setResponseRemove ] = useState()
    const serverRemoveEvents = async ({eventID, contact_check, reason}) => {
        try {
            const payload = {
                contact_check,
                reason
            }
            const urlEndpoint = `${BASE_PATH_API}/gift-table/v1/gift-table/${eventID}/cancel`
            const header = {
                method: 'PATCH',
                headers: { 'Content-Type':'application/json' },
                body: JSON.stringify(payload)
            } 
            const response = await fetch(urlEndpoint, header);
            const data = await response.json();
            if(data?.data){
                setResponseRemove(data?.data)
            }
        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }


    const cancelEvent = (events) => {
        const {eventID, contact_check, reason} = events
        serverRemoveEvents({eventID, contact_check, reason})
    }

    const changeEvent = (id) => {
        dispatch(showLoader());
        getEventTable(id)
    }

    const setPage = (page) => {
        // console.log('page: ',page)
        serverListCarts(page)
    }


    useEffect(()=>{
        if(giftTable){
            setResponse(giftTable?.results?.list)
            setResponsePag( sanitizePagination(giftTable) )
        }else{
            serverListCarts()
        }
    },[giftTable])


    useEffect(()=>{
        if(responseTable){
            const newEvent = {
                ...responseTable,
                evento: responseTable?.id
            }
            try{
                encodeStorage('GIFT_TABLE_DATA', newEvent)
            }catch(err){
                encodeStorageLatin('GIFT_TABLE_DATA', newEvent)
            }
            dispatch(setGiftTable(newEvent))
            const ruta = window.location.pathname
            if( ruta.indexOf('/my-table') >= 0){
                dispatch(hideLoader());
                window.location.reload()
            }else{
                setTimeout(()=>{
                    dispatch(hideLoader());
                    history.push(`/my-table`);
                },700)
            }
        }
    },[responseTable])


    return {
        response,
        responseRemove,
        responsePag,
        cancelEvent,
        changeEvent,
        setPage
    }
}

const ModalCM = (props) => {
    const {
        closeModal,
        setCancelarMR
    } = props

    const cancel = () => closeModal(true)
    const acept = () => setCancelarMR(true)
    return(
        <div className={Styles?.modalCancel}>
            <h3>Cancelar mesa</h3>
            <p>Estas a punto de cancelar tu mesa de regalos.
            ¿Estas seguro que quieres hacerlo?</p>
            <div className={Styles?.contentButtons}>
                <div className="btn secondaryButton" onClick={cancel}>Cancelar</div>
                <div className="btn primaryButton" onClick={acept}>Aceptar</div>
            </div>
        </div>
    )
}

const ModalAceptCM = (props) => {
    const {
        closeModal,
        setRemoveGT
    } = props

    const setForm = {motivo: '', contacto: 'on'}

    const [ formData, setFormData ] = useState(setForm)
    const [ disabledButton, setFormDisabledButton ] = useState(true)

    const handleSubmit = (event) => {
        event.preventDefault()
        // console.log('formData en submit: ',formData)
        
        if(!disabledButton && formData?.motivo?.length >= 3){
            setRemoveGT(formData)
        }
    }

    const cancel = () => closeModal(true)

    const handleChange = (event) => {
        const {
            value,
            name
        } = event?.target

        let contactarme = document.querySelector('[name="contacto"]').checked

        if(name === 'contacto' && !contactarme){
            setFormData({
                ...formData,
                [name]: 'off'
            })
        }else{
            setFormData({
                ...formData,
                [name]: value
            })
        }
    }

    useEffect(()=>{
        let contactarme = document.querySelector('[name="contacto"]')
        if(contactarme){
            contactarme.checked = true
        }
    },[])
    
    useEffect(()=>{
        if(formData){
            if(formData?.motivo?.length >= 3){
                setFormDisabledButton(false)
            }else{
                setFormDisabledButton(true)
            }
        }
    },[formData])

    return(
        <div className={Styles?.modalCancel}>
            <h3>Motivo de la cancelación</h3>
            <form onSubmit={handleSubmit}>
                <textarea 
                    id="motivo"
                    name="motivo"
                    className={Styles?.textarea}
                    onChange={handleChange}
                    autoFocus
                ></textarea>
                <label
                    className={Styles?.check}
                >
                    <input
                        id="contacto"
                        name="contacto"
                        type="checkbox"
                        onChange={handleChange}
                    />
                    Sears puede contactarme.
                </label>
            </form>
            <div className={Styles?.contentButtons}>
                <div className="btn secondaryButton" onClick={cancel}>Cancelar</div>
                <button onClick={handleSubmit} type="submit" className="btn primaryButton" disabled={disabledButton}>Aceptar</button>
            </div>
        </div>
    )
}

const ModalFinishCM = (props) => {
    const {
        closeModal
    } = props
    const cancel = () => closeModal(true)
    return(
        <div className={Styles?.modalCancel}>
            <img src={iconregalo} alt="" />
            <h3>Gracias</h3>
            <p>Tu mesa fue cancelada correctamente, Gracias por confiar en nosotros para formar parte de tus momentos más importantes.</p>
            <div className={Styles?.contentButtons}>
                <div className="btn primaryButton" onClick={cancel}>Aceptar</div>
            </div>
        </div>
    )
}


const MyEventsModule = () => {

    const { 
        response,
        responseRemove,
        responsePag,
        cancelEvent,
        changeEvent,
        setPage
    } = useTotalEventsGifts()

    const [ , dispatch ] = useStore( (state) => state?.giftTable?.myListOfGiftsTables?.results?.list)

    const [ modalRemove, setModalRemove ] = useState()
    const [ cancelarMR, setCancelarMR ] = useState(false)
    const [ removeFinish, setRemoveFinish ] = useState(false)
    const [ removeGT, setRemoveGT ] = useState()
    const [ idEvento, setIdEvento ] = useState()

    const isMobile = 'desktop'

    const goEvents = (id) => changeEvent(id)

    const remove = (id) => {
        setModalRemove(id)
        setIdEvento(id)
    }
    
    const closeModal = () => {
        setModalRemove()
        setIdEvento()
        setCancelarMR(false)
        setRemoveFinish(false)
        dispatch(hideLoader());
    }
    
    useEffect(()=>{
        if(removeGT){
            const final = {
                eventID: idEvento,
                contact_check: removeGT?.contacto,
                reason: removeGT?.motivo,
            }
            cancelEvent(final)
            dispatch(showLoader());
        }
    },[removeGT])
    
    useEffect(()=>{
        if(responseRemove){
            dispatch(hideLoader());
            forceUD(true)
            setRemoveFinish(true)
        }
    },[responseRemove])

    return(
        <>
            <div className={Styles?.contentMyGT}>
                <h1>Mis mesas de regalos</h1>
                <div>
                    {response && response?.length 
                        ?
                        response?.map((events, index) => {

                            let nombres = events?.festejados?.replace('&','y')
                            let eventos = events?.tipo
                            let numEventos = events?.id
                            let fecha = events?.fecha
                            let status = events?.estatus
                            let plan = events?.plan
                            return(
                                <div className={status === 'Open' ? `${Styles?.contMyGiftsTables} ${Styles?.active}` : Styles?.contMyGiftsTables} key={index}>
                                    <p className={Styles?.names} onClick={() => goEvents(numEventos)}>{nombres}</p>
                                    <p className={Styles?.events} onClick={() => goEvents(numEventos)}>{eventos}</p>
                                    <p className={Styles?.numEv} onClick={() => goEvents(numEventos)}>#{numEventos}</p>
                                    <p className={Styles?.dates} onClick={() => goEvents(numEventos)}>{fecha}</p>
                                    <p className={Styles?.status} onClick={() => goEvents(numEventos)}>{status === 'Open' ? 'Mesa abierta' : 'Mesa cancelada'}</p>
                                    {status === 'Open' 
                                        ? <p className={Styles?.buttons} onClick={() => remove(numEventos)}>Cancelar</p> 
                                        : <p className={Styles?.buttons} onClick={() => goEvents(numEventos)}>Consultar</p>
                                    }
                                </div>
                            )
                        })
                        : null
                    }
                </div>
                {response && response?.length 
                    ?
                        <div className={Styles?.pagination}>
                            <PaginationList
                                setPage={setPage}
                                selectedPage={responsePag?.current_page}
                                cantResults={responsePag?.total_items}
                                cantResultPerPage={responsePag?.items_per_page}
                            />
                        </div>
                    : null
                }
            </div>
            {modalRemove
                ? 
                    <ModalCloseGT
                        onClose={closeModal} 
                        isMobile={isMobile} 
                        type={isMobile === 'desktop' ? '' : 'full'} 
                        title={"Cancelar mesa"} 
                        closeBody="Cancelar mesa"
                    >
                        {!cancelarMR
                            ?
                                <ModalCM 
                                    closeModal={closeModal} 
                                    setCancelarMR={setCancelarMR}
                                />
                            : !removeFinish
                                ?
                                    <ModalAceptCM
                                        closeModal={closeModal} 
                                        setRemoveGT={setRemoveGT}
                                    />
                                :
                                    <ModalFinishCM
                                        closeModal={closeModal}
                                    />
                        }
                    </ModalCloseGT>
                : null
            }
        </>
    )
}

export default MyEventsModule